import React, { useContext, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import toast from "react-hot-toast";
import { FaGithub, FaGoogle } from "react-icons/fa";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/UserContext";
import './LogIn.css';

const LogIn = () => {
  const { logIn, google, github, setLoading } = useContext(AuthContext);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";
  console.log(from);
  // console.log(user);

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;

    const email = form.email.value;
    const password = form.password.value;
    console.log(email, password);
    logIn(email, password)
      .then((result) => {
        const user = result.user;
        console.log(user);
        form.reset();
        setError("");
        navigate(from, { replace: true });
  
        
      })
      .catch((error) => {
        console.error(error);
        setError(error.message);
      })
      // .finally(() =>{
      //   setLoading(false);
      // })
  };

  const googleIn = () => {
    google()
      .then((result) => {
        const user = result.user;
        console.log(user);
        navigate(from, { replace: true });
      })
      .catch((error) => console.error(error));
  };

  const githubIn = () => {
    github()
      .then((result) => {
        const user = result.user;
        console.log(user);
        navigate(from, { replace: true });
      })
      .catch((error) => console.error(error));
  };

  return (
    <div className="logIn mt-5">
      <div>
        <h1 className="container text-primary text-center">Please Log In</h1>
        <Form onSubmit={handleSubmit} className="container w-50 mt-5 ">
          <Form.Group className="text-start" controlId="formBasicEmail">
            <Form.Label><h6>Email address</h6></Form.Label>
            <Form.Control type="email" name="email" placeholder="Enter email" className=""/>
          </Form.Group>

          <Form.Group className="text-start" controlId="formBasicPassword">
            <Form.Label><h6 className="pt-3">Password</h6></Form.Label>
            <Form.Control
              type="password"
              name="password"
              placeholder="Password"
            />
          </Form.Group>
          <Form.Group className="text-start  pt-3" controlId="formBasicCheckbox">
            <Link to="/register" className="text-success">Please Register</Link>
          </Form.Group>
          <Button className="mt-4 pe-3 ps-3 ms-4 fw-semibold fs-5" variant="primary" type="submit">
            Log In
          </Button>
          <p className="text-danger">{error}</p>
        </Form>
      </div>
      <div className="photo me-5">
        <img
          src="https://img.freepik.com/premium-vector/secure-login-sign-up-concept-illustration-user-use-secure-login-password-protection-website-social-media-account-vector-flat-style_7737-2270.jpg?size=626&ext=jpg&uid=R75315196&ga=GA1.2.1721658491.1666825315"
          alt=""
          className="w-100 me-5 rounded-4 shadow-lg"
        ></img>
      </div>
      <div className="text-center me-5 mt-4">
          <div className="me-5">
            <Button
              className="fs-5 text-success shadow-lg ps-5 pe-5"
              onClick={googleIn}
              variant="light"
              size="lg"
            >
              <FaGoogle className="text-center"></FaGoogle>
              <small className="ps-2">Sign in with Google</small>
            </Button>
          </div>
          <div className="mt-3 me-5">
            <Button
              className="fs-5 ps-5 pe-5 shadow-lg"
              variant="light"
              onClick={githubIn}
            >
              <FaGithub></FaGithub>
              <small className="ps-2">Sign in with Github</small>
            </Button>
          </div>
        </div>
    </div>
  );
};

export default LogIn;
